import { render, staticRenderFns } from "./BlogPostCreatePage.vue?vue&type=template&id=6fec845e&scoped=true&"
import script from "./BlogPostCreatePage.vue?vue&type=script&lang=js&"
export * from "./BlogPostCreatePage.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostCreatePage.vue?vue&type=style&index=0&id=6fec845e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fec845e",
  null
  
)

export default component.exports